import React from 'react';

import { scaleLinear, max, tickFormat } from 'd3';

import { AxisBottom } from './AxisBottom';
import { AxisLeft } from './AxisLeft';
import { Marks } from './Marks';
import { Graph } from '../generalPlot/Graph';


const margin = {top: 50, left: 70, bottom: 50, right: 65};


export const LinePlot = ( {data, yScale, width, height, color, hovered, onHover, title, threshold=0.05} ) => {
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  const x = scaleLinear()
    .domain([0, max(data, d=>d.iteration)])
    .range([0, innerWidth])
    .nice();

  const y = yScale
    .range([innerHeight, 0])
    .nice();
  const formatter = tickFormat(0, 1, 5, "%");

  return (
    <Graph
      width={width}
      height={height}
      margin={margin}
    >
      <text 
        className="plot-title"
        x={innerWidth / 2} y={-15} textAnchor="middle">{title}</text>
      <AxisBottom 
        x={x}
        innerHeight={innerHeight}
      />
      <text 
        className="axis-label"
        x={innerWidth / 2} y={innerHeight + 35} textAnchor="middle">Optimization steps / #</text>
      <AxisLeft
        y={y}
        innerWidth={innerWidth}
        formatter={formatter}
      />
      <text 
        className="axis-label"
        transform={`translate(-55,${innerHeight/2}) rotate(-90)`}
        textAnchor="middle">Probability / %</text>
      <Marks
        data={data}
        x={x}
        y={y}
        threshold={threshold}
        color={color}
        onHover={onHover}
        hovered={hovered}
      />
      ))}
    </Graph>
  );
};
